import {combineReducers} from "@reduxjs/toolkit";
import AdminAuthReducer from './adminAuthSlice';

const adminReducers = () => combineReducers({
  auth: AdminAuthReducer,
});

export default adminReducers;
